export default __webpack_public_path__ + "static/media/invite-member.260b03a9.svg";